var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.64453 4.80694C1.64453 3.9552 1.64453 3.52978 1.90918 3.26513C2.17382 3.00049 2.59924 3.00049 3.45098 3.00049H8.87034C9.72208 3.00049 10.1475 3.00049 10.4121 3.26513C10.6768 3.52978 10.6768 3.9552 10.6768 4.80694C10.6768 5.01965 10.6768 5.12623 10.6109 5.19262C10.5445 5.25855 10.4374 5.25855 10.2252 5.25855H2.09614C1.88343 5.25855 1.77685 5.25855 1.71047 5.19262C1.64453 5.12623 1.64453 5.0192 1.64453 4.80694ZM1.64453 8.87146C1.64453 9.7232 1.64453 10.1486 1.90918 10.4133C2.17382 10.6779 2.59924 10.6779 3.45098 10.6779H8.87034C9.72208 10.6779 10.1475 10.6779 10.4121 10.4133C10.6768 10.1486 10.6768 9.7232 10.6768 8.87146V6.61339C10.6768 6.40068 10.6768 6.2941 10.6109 6.22771C10.5445 6.16178 10.4374 6.16178 10.2252 6.16178H2.09614C1.88343 6.16178 1.77685 6.16178 1.71047 6.22771C1.64453 6.2941 1.64453 6.40113 1.64453 6.61339V8.87146Z",
    fill: "#6796CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90234 2.09717V3.45201M8.41847 2.09717V3.45201",
    stroke: "#6796CF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconData);
export default __webpack_public_path__ + "static/media/IconData.92eeccbf24e31776892f9ef3c90c6738.svg";
export { ForwardRef as ReactComponent };